import { Routes } from '@angular/router';

const title = 'Publicaciones';
const data = { title, isShowBreadcrumb: true };

export const ROUTES: Routes = [


  {
    path: 'adopcion',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Adopciones' }] },
        loadComponent: () => import('./pages/adopcion-lista/adopcion-lista.component'),
      },
    
    ],
  },
 
];
